import { h } from 'preact';
import { render } from '@testing-library/preact';
import { expect } from 'chai';
import { MessagesManager } from '@oracle/oraclejet-preact/UNSAFE_Message';

const DATA = [
  {
    key: "ErrorMessage",
    data: {
      severity: "error",
      summary: "Primary Text",
      detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      closeAffordance: "on",
      timestamp: new Date().toISOString()
    }
  },
  {
    key: "WarningMessage",
    data: {
      severity: "warning",
      summary: "Primary Text",
      detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      closeAffordance: "on",
      timestamp: new Date().toISOString()
    }
  },
  {
    key: "ConfirmationMessage",
    data: {
      severity: "confirmation",
      summary: "Primary Text",
      detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      closeAffordance: "on",
      timestamp: new Date().toISOString()
    }
  },
  {
    key: "InfoMessage",
    data: {
      severity: "info",
      summary: "Primary Text",
      detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      closeAffordance: "on",
      timestamp: new Date().toISOString()
    }
  }
];
const START_ANIM = (
  _element: Element,
  _action: string,
  _effects: string | object | (string|object)[],
  _component?: object
) => Promise.resolve(true);

describe('Test MessagesManager component', () => {
  it('child renderer', async function () {
    const content = render(
      <MessagesManager
        data={DATA}
        startAnimation={START_ANIM}>
        {({ index, item }) => (
          <div style="border: 1px solid gray; padding: 5px; background-color: orange;"
            data-testid={item.key}>
            <div>index: {index}</div>
            <div>key: {item.key}</div>
            <div>severity: {item.data.severity}</div>
            <div>summary: {item.data.summary}</div>
            <div>detail: {item.data.detail}</div>
            <div>timestamp: {item.data.timestamp}</div>
          </div>
        )}
      </MessagesManager>
    );

    // since the function we're passing to Array.map is async, we need to wait on all
    // those return promises before continuing, hence the "await Promise.all()"
    await Promise.all(DATA.map(async item => {
      const message = await content.findByTestId(item.key);
      expect(message).not.null;
      expect(message.style.backgroundColor).to.equal('orange');

      // just look for a single field as an example, no need to find every field
      const sevElem = await content.findByText(`severity: ${item.data.severity}`);
      expect(sevElem).not.null;
    }));
  });
});
